import { render, staticRenderFns } from "./agentWithdrawal.vue?vue&type=template&id=1023ec9f&scoped=true&"
import script from "./agentWithdrawal.vue?vue&type=script&lang=js&"
export * from "./agentWithdrawal.vue?vue&type=script&lang=js&"
import style0 from "./agentWithdrawal.vue?vue&type=style&index=0&id=1023ec9f&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1023ec9f",
  null
  
)

export default component.exports